import React, { Component } from "react";
import { Div } from "atomize";
import { Anchor } from "atomize/dist";
import { IsValidUrl } from "../../utilities/helpers";

export default class ImageLink extends Component {
  render() {
    const { children, link, ...rest } = this.props;
    return (
      <Div {...rest}>
        {link && IsValidUrl(link) ? (
          <Anchor href={link}>
            <Div h="100%">{children}</Div>
          </Anchor>
        ) : (
          <Div h="100%">{children}</Div>
        )}
      </Div>
    );
  }
}
